jQuery(document).ready(function(){

    // Mobile Menu

    jQuery('#mobile-menu').click(function(){

		jQuery('header').toggleClass('mobile-active');

		if(jQuery('header').hasClass('mobile-active')) {
			jQuery('body, html').css('overflow-y', 'hidden');
		} else {
			jQuery('body, html').css('overflow-y', 'auto');
		}
	});

    jQuery('.menu-item-has-children').click(function() {
        jQuery(this).toggleClass('active');
    });

    // Accordion

    jQuery('.drop-open').click(function() {
        jQuery(this).toggleClass('active');
        jQuery(this).siblings('.main-content').slideToggle('fast');
    });
});


jQuery(window).load(function(){
    jQuery('.slider, #image-slider').flickity({
        autoPlay: 3000,
        prevNextButtons: true,
        imagesLoaded: true,
        pageDots: true,
        setGallerySize: true,
        wrapAround: true,
        adaptiveHeight: true
    });

    jQuery('.home-slider, .image-gallery').addClass('active');

    jQuery('#image-slider-control').flickity({
        asNavFor: '#image-slider',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        imagesLoaded: true,
    });
});
